// extracted by mini-css-extract-plugin
export default {"volumeBar":"progressBar_volumeBar__lnxyl"};